import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"

import "./Profile.vue?vue&type=style&index=0&id=623e3288&lang=css"

const __exports__ = script;

export default __exports__